module.exports = __webpack_public_path__ + "static/img/accueil.216a8af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/entreprise/accueil.jpg
// module id = tJ2D
// module chunks = 0